var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6235 4.63944C17.5218 4.2564 17.3213 3.90679 17.042 3.62564C16.7626 3.34448 16.4144 3.14165 16.032 3.03744C14.6287 2.65869 9 2.65869 9 2.65869C9 2.65869 3.37125 2.65869 1.96725 3.03744C1.58506 3.14183 1.23697 3.34474 0.957808 3.62588C0.678646 3.90701 0.478194 4.25652 0.3765 4.63944C0 6.05244 0 8.99994 0 8.99994C0 8.99994 0 11.9474 0.3765 13.3604C0.478189 13.7435 0.678732 14.0931 0.958043 14.3742C1.23736 14.6554 1.58563 14.8582 1.968 14.9624C3.37125 15.3412 9 15.3412 9 15.3412C9 15.3412 14.6288 15.3412 16.0328 14.9624C16.4152 14.8583 16.7635 14.6555 17.0428 14.3743C17.3221 14.0932 17.5226 13.7435 17.6243 13.3604C18 11.9474 18 8.99994 18 8.99994C18 8.99994 18 6.05244 17.6235 4.63944ZM7.15875 11.6759V6.32394L11.8635 8.99994L7.15875 11.6759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b31ca9a748843c8d0f08acd7a1bdd005.svg";
export { ForwardRef as ReactComponent };